import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BaseService, EnvironmentService, ResponseResult } from 'tnx-shared';

@Injectable({
    providedIn: 'root'
})

export class AddressService extends BaseService {
    entityName = 'Address';
    serviceCode = 'admin';
    constructor(http: HttpClient, injector: Injector,
        private _environmentService: EnvironmentService) {
        super(http, injector, ``);
        this.endPoint = _environmentService.getHttpServiceEndpointWithVersion(this.serviceCode);
                this.serviceUri = `${this.endPoint}/${this.entityName}`;
    }

    GetAllWard(level: number, key?: string, offset?: number, limit?: number
        , sortField?: string, isAsc: boolean = null): Promise<ResponseResult> {
        let queryString = `?level=${level}`;
        queryString += `&key=${key}`;

        if (!offset) {
            offset = 0;
        }

        queryString += `&offset=${offset}`;


        if (!limit) {
            limit = this.LIMIT_DEFAULT;

        }
        queryString += `&limit=${limit}`;
        if (sortField) {
            queryString += `&sortField=${sortField}&isAsc=${isAsc}`;
        }
        const apiUrl = `${this.serviceUri}/AdministrativeDivision${queryString}`;
        return this.defaultGet(apiUrl);
    }


}
